import { ENV } from '@/app/config/env';
import { hasPostHogCookie, readSemFormCookies } from '@/app/lib/sem-form-experiment';

let posthogPromise: Promise<typeof import('posthog-js').default> | undefined;

/** Loads and initializes posthog-js once. */
export const loadPostHog = async () => {
  posthogPromise ??= import('posthog-js').then(({ default: posthog }) => {
    if (ENV.POSTHOG_KEY && !posthog.__loaded) {
      const cookies = typeof document === 'undefined' ? '' : document.cookie;
      const semForm = readSemFormCookies(cookies);
      posthog.init(ENV.POSTHOG_KEY, {
        // The id the middleware assigned the SEM form test with, so the exposure, page events and lead match.
        ...(semForm.distinctId && !hasPostHogCookie(cookies) ? { bootstrap: { distinctID: semForm.distinctId } } : {}),
        api_host: 'https://us.i.posthog.com',
        person_profiles: 'identified_only',
        capture_pageview: false,
        capture_pageleave: true,
        // Loads the PostHog site destinations, which is how the Rockerbox pixel records
        // ad-landing visits on /df. Conversions reach Rockerbox from server-side files instead.
        opt_in_site_apps: true,
      });
      // Tags the visitor's events with their SEM form test variant.
      if (semForm.variant) posthog.register({ sem_form_variant: semForm.variant });
    }

    return posthog;
  });

  return posthogPromise;
};
